import * as React from "react";
import Message from "../../Models/Message/Message";

import MessageView from "../MessageView/MessageView";

import "./MessageContainer.css";

interface MessageContainerProps {
    messages: Message[];
}

class MessageContainer extends React.Component<MessageContainerProps, any> {
    private scrollContainerRef: React.RefObject<HTMLUListElement>;
    constructor(props: MessageContainerProps) {
        super(props);
        this.scrollContainerRef = React.createRef();
    }

    scrollToBottom = () => {
        const height = this.scrollContainerRef.current.scrollHeight;
        this.scrollContainerRef.current.scrollTop = height;
    }

    componentDidMount() {
        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    render() {
        return (
            <ul className="messageContainer" ref={this.scrollContainerRef}>
                { this.props.messages.map((message: Message, index: number) => {
                    return <MessageView key={message.timestamp} message={message} />;
                })}
            </ul>
        );
    }
}

export default MessageContainer;
